(function () {
  const STORAGE_KEY = 'cc_cart_popup_enabled';
  const ADD_WINDOW_MS = 2000;
  const TOAST_TIMEOUT = 3500;

  let lastAddAt = 0;

  function isPopupEnabled() {
    const v = localStorage.getItem(STORAGE_KEY);
    return v === null ? true : v === '1';
  }

  function setPopupEnabled(on) {
    localStorage.setItem(STORAGE_KEY, on ? '1' : '0');
  }

  function syncToggles() {
    const on = isPopupEnabled();
    document.querySelectorAll('.cart-popup-toggle-input').forEach((cb) => {
      cb.checked = on;
    });
  }

  function markRecentAdd() {
    lastAddAt = Date.now();
  }

  function wasRecentAdd() {
    return Date.now() - lastAddAt < ADD_WINDOW_MS;
  }

  function consumeRecentAdd() {
    lastAddAt = 0;
  }

  function isCartAddUrl(url) {
    if (!url) return false;
    try {
      const u = typeof url === 'string' ? url : url.url || String(url);
      return /\/cart\/add(\.js)?(\?|$)/.test(u);
    } catch (e) {
      return false;
    }
  }

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  // showToast({ message, showLink, variant, action, timeout })
  //   message  : tekst in de toast (default 'Toegevoegd aan winkelwagen')
  //   showLink : 'Winkelwagen bekijken' link tonen (default true voor de
  //              standaard add-toast; false voor max-reached toasts want
  //              de cart is dan al maximaal vol).
  //   variant  : optionele class-suffix ('max', 'wishlist', etc.) voor styling-haakje.
  //   action   : optionele button { label, onClick } voor undo-acties etc.
  //              Vervangt de cart-link wanneer aanwezig. onClick krijgt geen
  //              argument; sluit de toast vanzelf na klik.
  //   timeout  : ms voor auto-hide (default TOAST_TIMEOUT = 3500)
  function showToast(opts) {
    opts = opts || {};
    const message = opts.message || 'Toegevoegd aan winkelwagen';
    const showLink = opts.showLink !== false && !opts.action;
    const variant = opts.variant || 'add';
    const action = opts.action || null;
    const timeout = typeof opts.timeout === 'number' ? opts.timeout : TOAST_TIMEOUT;

    let toast = document.getElementById('cc-cart-toast');
    if (!toast) {
      toast = document.createElement('div');
      toast.id = 'cc-cart-toast';
      toast.className = 'cc-cart-toast';
      document.body.appendChild(toast);
    }
    // Class reset per show — onderscheid stylings (success vs blocking vs custom)
    toast.classList.remove('cc-cart-toast--add', 'cc-cart-toast--max', 'cc-cart-toast--wishlist');
    toast.classList.add('cc-cart-toast--' + variant);

    let html = '<span class="cc-cart-toast__msg">' + escapeHtml(message) + '</span>';
    if (action && action.label) {
      html += '<button type="button" class="cc-cart-toast__action">' + escapeHtml(action.label) + '</button>';
    } else if (showLink) {
      html += '<a class="cc-cart-toast__link" href="/cart">Winkelwagen bekijken</a>';
    }
    toast.innerHTML = html;

    if (action && typeof action.onClick === 'function') {
      const btn = toast.querySelector('.cc-cart-toast__action');
      if (btn) {
        btn.addEventListener('click', function () {
          try { action.onClick(); } catch (e) { console.error(e); }
          toast.classList.remove('is-visible');
          clearTimeout(toast._hideTimer);
        }, { once: true });
      }
    }

    toast.classList.add('is-visible');
    clearTimeout(toast._hideTimer);
    toast._hideTimer = setTimeout(() => toast.classList.remove('is-visible'), timeout);
  }

  // Expose voor hergebruik door andere scripts (wishlist, etc.).
  // Eén toast-singleton door de hele site; bellers krijgen automatisch
  // dezelfde plaatsing/animatie/styling.
  window.ccShowToast = showToast;

  function hookFetch() {
    const nativeFetch = window.fetch;
    if (!nativeFetch || nativeFetch._ccHooked) return;
    const hooked = function (input, init) {
      const isAdd = isCartAddUrl(input);
      const promise = nativeFetch.call(this, input, init);
      if (isAdd) {
        promise
          .then((res) => {
            if (res && res.ok) markRecentAdd();
          })
          .catch(() => {});
      }
      return promise;
    };
    hooked._ccHooked = true;
    window.fetch = hooked;
  }

  function patchCartElement(tagName) {
    const Ctor = customElements.get(tagName);
    if (!Ctor || Ctor.prototype._ccPatched) return;
    const origOpen = Ctor.prototype.open;
    if (typeof origOpen !== 'function') return;
    Ctor.prototype.open = function () {
      // Page-level opt-out: bv. /pages/mijn-wishlist zet deze flag zodat
      // de drawer hier nooit opent (drawer kan niet sectie-replacen na
      // onze custom add-to-cart calls). Toast wordt nog wel getoond bij
      // recent-add, anders krijgt de gebruiker geen feedback.
      if (window.ccDisableCartDrawer) {
        if (wasRecentAdd()) {
          consumeRecentAdd();
          showToast();
        }
        return;
      }
      // Na een add: toast i.p.v. drawer als de popup-voorkeur uit staat OF als
      // de pagina ccToastOnAdd zet (bv. artikelpagina's, waar de drawer niet
      // betrouwbaar kan section-replacen na add). Handmatige opens (cart-icoon,
      // geen recente add) blijven gewoon de drawer openen.
      if (wasRecentAdd() && (!isPopupEnabled() || window.ccToastOnAdd)) {
        consumeRecentAdd();
        showToast();
        return;
      }
      return origOpen.apply(this, arguments);
    };
    Ctor.prototype._ccPatched = true;
  }

  function observeDrawerMutations() {
    const target = document.body;
    if (!target || !window.MutationObserver) return;
    const obs = new MutationObserver((muts) => {
      for (const m of muts) {
        for (const node of m.addedNodes) {
          if (node.nodeType !== 1) continue;
          if (
            node.classList?.contains('cart-popup-toggle-input') ||
            node.querySelector?.('.cart-popup-toggle-input')
          ) {
            syncToggles();
            return;
          }
        }
      }
    });
    obs.observe(target, { childList: true, subtree: true });
  }

  // Luister naar cart-max-reached events vanuit qty-limits.js. Toon de
  // juiste toast en consume de recent-add marker zodat de blokkerende
  // toast NIET ook nog door de standaard "Toegevoegd"-toast gevolgd wordt.
  function onCartMaxReached(e) {
    const detail = (e && e.detail) || {};
    let message;
    if (detail.reason === 'meta-max' && detail.max) {
      message = 'Maximum aantal van ' + detail.max + ' bereikt';
    } else {
      // 'inv-max' of fallback: alle voorraad zit al in de winkelwagen
      message = 'Alle beschikbare items al in winkelwagen';
    }
    consumeRecentAdd();
    showToast({ message: message, showLink: false, variant: 'max' });
  }

  function init() {
    hookFetch();
    ['cart-notification', 'cart-drawer'].forEach((t) => {
      if (customElements.get(t)) {
        patchCartElement(t);
      } else if (customElements.whenDefined) {
        customElements.whenDefined(t).then(() => patchCartElement(t));
      }
    });

    syncToggles();
    observeDrawerMutations();

    document.addEventListener('change', (e) => {
      const cb = e.target.closest('.cart-popup-toggle-input');
      if (!cb) return;
      setPopupEnabled(cb.checked);
      syncToggles();
    });

    document.addEventListener('shopify:section:load', syncToggles);
    document.addEventListener('cc:cart-max-reached', onCartMaxReached);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
